import axios from 'axios';
import { setAuthorizationHeaders } from '@/api/utils';
import { onRejected } from '@/api/interceptor';

// old python DeepAdmin API
const deepadminApi = axios.create({
  baseURL: `${import.meta.env.VITE_DEEPADMIN_API_BASE_URL}/v1`
});

deepadminApi.interceptors.request.use(async (config) => {
  const headers = {};

  // DeepAdmin resources (e.g. user preferences, org subjects) always belong
  // to the logged-in identity, so prefer the full access token even when a
  // document token is also present (e.g. on the public document route).
  await setAuthorizationHeaders(headers, { preferAccessToken: true });

  Object.assign(config.headers, headers);
  return {
    ...config
  };
});

deepadminApi.interceptors.response.use((response) => {
  return response;
}, onRejected);

export default deepadminApi;
